import DOMPurify from 'dompurify';
import { normalizeStorageUrl } from './storageUrl';

export const isSvgUrl = url => {
  if (!url) return false;

  const normalized = url.split('?')[0].split('#')[0].toLowerCase();
  return (
    normalized.endsWith('.svg') || url.toLowerCase().includes('image/svg')
  );
};

export const sanitizeInlineSvg = markup =>
  DOMPurify.sanitize(markup, {
    USE_PROFILES: { svg: true, svgFilters: true },
  });

export const prepareInlineSvgMarkup = raw => {
  const doc = new DOMParser().parseFromString(raw, 'image/svg+xml');
  const svg = doc.querySelector('svg');
  if (!svg) return '';

  if (svg.hasAttribute('viewBox')) {
    svg.removeAttribute('width');
    svg.removeAttribute('height');
  }

  svg.setAttribute('width', '100%');
  svg.setAttribute('height', '100%');
  svg.setAttribute('class', 'inline-svg');
  if (!svg.hasAttribute('preserveAspectRatio')) {
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  }

  return sanitizeInlineSvg(svg.outerHTML);
};

export const fetchInlineSvgMarkup = async (url, { signal } = {}) => {
  const response = await fetch(normalizeStorageUrl(url), { signal });
  if (!response.ok) {
    throw new Error(`SVG fetch failed: ${response.status}`);
  }

  const raw = await response.text();
  return prepareInlineSvgMarkup(raw);
};
